//cookie popup

export default () => {

    // for share box
    document.querySelector('.clipboard') && document.querySelector('.clipboard').addEventListener('click', function (e) {
        e.preventDefault();
        let changeText = document.getElementById('copy-link'),
            copyText = document.getElementById('shareLink');
        changeText.innerHTML = 'Copied';
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
    });
}